module.exports = __webpack_public_path__ + "static/media/full-logo-blue.7d7194fa.png";